import React from 'react'

// material ui layout
import Grid from '@mui/material/Grid'

// material ui forms
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import Checkbox from '@mui/material/Checkbox'
import FormHelperText from '@mui/material/FormHelperText'

// local components
import LegacyDietaryRestrictionsWarning from './LegacyDietaryRestrictionsWarning'
import NoNopeWarning from './NoNopeWarning'

// shared components
import FormConditionalSubgroup from 'components/atoms/FormConditionalSubgroup'
import FormTextFieldWithValidation from 'components/shared/FormTextFieldWithValidation'
import FormControlWithErrorHelper from 'components/shared/FormControlWithErrorHelper'

const DietaryRestrictionsForm = props => {
  const {
    // via EditCamperContainer:
    form, // via redux state
    formErrors, // via withFormResults
    camper, // via withQuery
    dietaryRestrictions, // via withQuery

    // via CamperFormContainer:
    onChangeCamperFormField, // via withEventHandlers
    onChangeArrayField, // via withEventHandlers
    onChangeBooleanStringField // via withEventHandlers
  } = props

  const displayNoNopeDietWarning = form.noNopeDietWarning
  return (
    <>
      {form.hasLegacyDietaryRestrictions && (
        <LegacyDietaryRestrictionsWarning
          dietaryRestrictions={dietaryRestrictions}
          camperRestrictions={camper.dietaryRestrictions}
        />
      )}

      <FormControlWithErrorHelper
        component='fieldset'
        required
        errorsObject={formErrors}
        errorField='dietaryRestrictions'
      >
        <FormLabel htmlFor='dietaryRestrictions' component='legend'>
          Dietary Restrictions
        </FormLabel>
        <RadioGroup
          value={String(form.hasDietaryRestrictions)}
          onChange={onChangeBooleanStringField('hasDietaryRestrictions')}
          aria-label='has dietary restrictions'
          name='hasDietaryRestrictions'
        >
          <FormControlLabel value='true' control={<Radio />} label='Yes' />
          <FormControlLabel value='false' control={<Radio />} label='No' />
        </RadioGroup>
      </FormControlWithErrorHelper>

      <FormConditionalSubgroup condition={form.hasDietaryRestrictions}>
        <FormControl component='fieldset' margin='normal' fullWidth>
          <FormLabel htmlFor='dietaryRestrictions' component='legend'>
            Choose restricted foods
          </FormLabel>
          <FormGroup>
            <Grid container spacing={1}>
              {dietaryRestrictions.map(({ name }) => (
                <Grid item xs={6} sm={4} key={name}>
                  <FormControlLabel
                    checked={
                      form.dietaryRestrictions != null &&
                      form.dietaryRestrictions.includes(name)
                    }
                    onChange={onChangeArrayField('dietaryRestrictions', name)}
                    value={name}
                    control={<Checkbox />}
                    label={name}
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
        </FormControl>
        <FormTextFieldWithValidation
          label='Other'
          form={form}
          field='dietaryRestrictionsOther'
          onChange={onChangeCamperFormField}
          errors={formErrors}
          multiline
        />
        <FormConditionalSubgroup condition={displayNoNopeDietWarning}>
          <NoNopeWarning field='dietary restrictions' />
        </FormConditionalSubgroup>
      </FormConditionalSubgroup>
    </>
  )
}

export default DietaryRestrictionsForm
